import { generatePath, Navigate, useParams } from 'react-router-dom';
import { useNavigateRoute } from 'src/utils/routing';
import { trimDuplicatedSlashes } from 'src/utils/routing/use-navigate-route';

/**
 * Navigates to a given route while preserving url param values
 *
 * Example:
 * If you want to redirect from "test/:id" to "new-test/:id",
 * this component ensures that "test/123" redirects to "new-test/123",
 * correctly preserving the actual "id" value
 *
 * Destination paths are resolved as app-absolute (and partner-prefixed when
 * needed). A bare relative `to` like `settings/billing` would otherwise be
 * appended onto the current URL by React Router — e.g. `/settings/stripe`
 * + `settings/billing` → `/settings/stripe/settings/billing`.
 */
export const NavigateWithParams = ({ to }: { to: string }) => {
  const params = useParams();
  const { partnerPrefix } = useNavigateRoute();
  const path = generatePath(to, params);
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const destination = partnerPrefix
    ? trimDuplicatedSlashes(`/${partnerPrefix}${normalized}`)
    : normalized;

  return <Navigate to={destination} replace />;
};
